import * as React from 'react';
// eslint-disable-next-line import/no-cycle
import { ToggleLeft, ToggleRight } from '../../Icons';
import styles from '/Shared/PageElements/toggle-icon.module.css';

interface ToggleIconProps {
    name: string;
    active: boolean;
    className?: string;
    message?: string;
    toggle: (section: string) => Promise<void>;
    hide?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export const LeftToggleIcon: React.FC<ToggleIconProps> = ({ name, active, className = '', message = '', toggle, hide = false }) => {    
    if (hide) return null;
    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
            className={`${styles.ActiveToggleIcon} ${className}`} 
            data-qa={`toggle-icon-${name}`}
            onClick={async () => {
                active = !active;
                await toggle(name);                
            }}
        >
            {active ? <ToggleRight /> : <ToggleLeft />}
            {message && <p>{message}</p>}
        </div>
    );
};